import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import rocketAnimation from '../Assets/paper-rocket-loader.json';
import bgImage from '../Assets/career-pulse-bg.png';

const CareerPulseLoader = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/chat'); // or /career-progress if needed
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div
      className="h-screen w-full overflow-auto flex flex-col items-center justify-start text-center px-4 py-10"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {/* 🚀 Rocket Animation */}
      <div className="w-44 sm:w-52 md:w-64 mt-10 mb-6">
        <Lottie animationData={rocketAnimation} loop={true} />
      </div>

      {/* Loading Text */}
      <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#FF5A3D] font-syne px-2 leading-snug">
        Loading... Please wait as we prepare something amazing for you.
      </h1>

      <p className="mt-4 text-base sm:text-lg text-stone-800 font-semibold font-sora px-4">
        “While AI is changing some jobs, others are rising fast…” 🔥
      </p>

      {/* List Section */}
      <ul className="mt-8 mb-20 bg-white/50 backdrop-blur-lg rounded-3xl px-6 sm:px-10 py-6 sm:py-8 shadow-xl text-left space-y-5 w-full max-w-[90%] sm:max-w-[700px] text-stone-800 font-sora text-sm sm:text-base md:text-lg font-medium">
        <li>🚚 Supply chain jobs are evolving</li>
        <li>🧑🏽‍🌾 Agriculture tech is booming</li>
        <li>🧪 Bio-tech, climate careers, and startups are growing in India</li>
        <li>🎨 Creative careers are being redefined, not replaced</li>
      </ul>
    </div>
  );
};

export default CareerPulseLoader;
